import { Modal, ModalBody, ModalContent } from '@nextui-org/react'
import React, { useContext, useEffect } from 'react'
import { Context } from '../waxplorer/Waxplorer'
import SellPopup from '../popups/SellPopup'
import EditPopup from '../popups/EditPopup'
import TransferPopup from '../popups/TransferPopup'
import BuyPopup from '../popups/BuyPopup'
import BuyDropPopup from '../popups/BuyDropPopup'
import UnpackPopup from '../popups/UnpackPopup'
import BurnPopup from '../popups/BurnPopup'
import BreakPopup from '../popups/BreakPopup'
import AuctionPopup from '../popups/AuctionPopup'
import BidPopup from '../popups/BidPopup'
import BuyOfferPopup from '../popups/BuyOfferPopup'
import SellOfferPopup from '../popups/SellOfferPopup'

export const ModalActions = ({
    action,
    asset,
    listing,
    auction,
    drop,
    amount,
    callBack,
}) => {
    const [, dispatch] = useContext(Context)

    const buyElement = (
        <BuyPopup
            asset={asset}
            listing={listing}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const buyDropElement = (
        <BuyDropPopup
            drop={drop}
            amount={amount}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
                dispatch({ type: 'SET_DROP', payload: '' })
            }}
            action={action}
            callBack={callBack}
        />
    )

    const sellElement = (
        <SellPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const editElement = (
        <EditPopup
            asset={asset}
            listing={listing}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const transferElement = (
        <TransferPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const unpackElement = (
        <UnpackPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const claimElement = (
        <UnpackPopup
            asset={asset}
            claimOnly={true}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const burnElement = (
        <BurnPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const breakElement = (
        <BreakPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const auctionElement = (
        <AuctionPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const bidElement = (
        <BidPopup
            auction={auction}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const buyOfferElement = (
        <BuyOfferPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    const sellOfferElement = (
        <SellOfferPopup
            asset={asset}
            closeCallBack={() => {
                dispatch({ type: 'SET_ACTION', payload: '' })
            }}
            callBack={callBack}
        />
    )

    useEffect(() => {}, [action])

    const getModalSize = (action) => {
        switch (action) {
            case 'addpicture':
                return 'sm'
            case 'auction':
                return '2xl'
            case 'bid':
                return '3xl'
            case 'bulk_buy':
                return 'xl'
            case 'buy':
                return '3xl'
            case 'redeem':
                return '3xl'
            case 'tokenize':
                return '3xl'
            case 'buy_drop':
                return '3xl'
            case 'burn_asset':
                return '3xl'
            case 'buy_pfp':
                return '3xl'
            case 'create_buyoffer':
                return '3xl'
            case 'accept_buyoffer':
                return '3xl'
            case 'backasset':
                return '3xl'
            case 'buy_wax':
                return '3xl'
            case 'sell':
                return '3xl'
            case 'unpack':
                return '3xl'
            case 'transfer_wax':
                return 'sm'
            case 'editoffer':
                return 'sm'
            case 'bulk_cancel':
                return 'sm'
            case 'bulk_transfer':
                return 'sm'
            case 'disable_filter':
                return 'sm'
            case 'skip_confirmations':
                return 'sm'
            case 'deleteDrop':
                return 'sm'
            case 'deletePackRelease':
                return 'sm'
            case 'createPackRelease':
                return 'sm'
            case 'updateDropMaxClaimable':
                return 'sm'
            case 'updateDropReferral':
                return 'sm'
            case 'trade':
                return 'md'
            case 'stake_honey':
                return 'lg'
            case 'unstake_honey':
                return 'lg'
            case 'updateDropAccountLimit':
                return 'lg'
            case 'updateDropStartEndDate':
                return 'lg'
            case 'unstake_cpu_net':
                return 'lg'
            case 'setTag':
                return 'xl'
            case 'updateDropPrice':
                return '2xl'
            case 'createPackMod':
                return '2xl'
            case 'suggestTag':
                return '2xl'
            default:
                return 'xl'
        }
    }

    return (
        <Modal
            isDismissable={false}
            size={getModalSize(action)}
            isOpen={action}
            onClose={() => {
                callBack({ success: false })
            }}
            scrollBehavior="inside"
            classNames={{
                wrapper: 'z-[1300]',
                body: 'p-0',
                closeButton:
                    'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
            }}
        >
            <ModalContent>
                <>
                    <ModalBody className="px-0">
                        {action === 'buy' ? buyElement : null}
                        {action === 'sell' ? sellElement : null}
                        {action === 'unpack' ? unpackElement : null}
                        {action === 'claim_pack' ? claimElement : null}
                        {action === 'edit' ? editElement : null}
                        {action === 'transfer' ? transferElement : null}
                        {action === 'burn_asset' ? burnElement : null}
                        {action === 'break_asset' ? breakElement : null}
                        {action === 'buy_drop' || action === 'buy_pfp'
                            ? buyDropElement
                            : null}
                        {action === 'auction' ? auctionElement : null}
                        {action === 'bid' ? bidElement : null}
                        {action === 'create_buyoffer' ? buyOfferElement : null}
                        {action === 'accept_buyoffer' ? sellOfferElement : null}
                    </ModalBody>
                </>
            </ModalContent>
        </Modal>
    )
}
